/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maple_Raw_Ox_NestInputs */

const en_maple_raw_ox_nest = /** @type {(inputs: Maple_Raw_Ox_NestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const de_maple_raw_ox_nest = /** @type {(inputs: Maple_Raw_Ox_NestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Maple_Raw_Ox_NestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const maple_raw_ox_nest = /** @type {((inputs?: Maple_Raw_Ox_NestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maple_Raw_Ox_NestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_maple_raw_ox_nest(inputs)
	return de_maple_raw_ox_nest(inputs)
});